import { http } from './request';
import type {
  LoginRequest,
  LoginResponse,
  RegisterRequest,
  RegisterResponse,
  RefreshTokenRequest,
  TokenResponse,
  UserInfo,
  UpdateUserRequest,
  ChangePasswordRequest,
  ForgotPasswordRequest,
  ResetPasswordRequest,
} from '../types/auth';
import type { ApiResponse } from '../types/api';

export const authApi = {
  // 用户登录
  login: (data: LoginRequest) =>
    http.post<LoginResponse>('/api/v1/auth/login', data),

  // 用户注册
  register: (data: RegisterRequest) =>
    http.post<RegisterResponse>('/api/v1/auth/register', data),

  // 刷新Token
  refreshToken: (data: RefreshTokenRequest) =>
    http.post<TokenResponse>('/api/v1/auth/refresh', data),

  // 用户登出
  logout: () =>
    http.post<void>('/api/v1/auth/logout'),

  // 获取当前用户信息
  getCurrentUser: () =>
    http.get<UserInfo>('/api/v1/auth/me'),

  // 更新当前用户信息
  updateCurrentUser: (data: UpdateUserRequest) =>
    http.put<UserInfo>('/api/v1/auth/me', data),

  // 修改密码
  changePassword: (data: ChangePasswordRequest) =>
    http.put<void>('/api/v1/auth/me/password', data),

  // 忘记密码
  forgotPassword: (data: ForgotPasswordRequest) =>
    http.post<{ message: string }>('/api/v1/auth/forgot-password', data),

  // 重置密码
  resetPassword: (data: ResetPasswordRequest) =>
    http.post<{ message: string }>('/api/v1/auth/reset-password', data),
};

// 注意：verifyEmail API 后端暂未实现
